module.exports = __webpack_public_path__ + "static/tejiendo-comunidad-2899e37a8049a53b4bb95ad75f45d7ee.jpg";